module.exports = __webpack_public_path__ + "img/918b94a48f0b46878d753593223ea5f6.acae71d6.jpg";